import { render } from "./army-stats-container.vue?vue&type=template&id=2296b595&scoped=true&ts=true"
import script from "./army-stats-container.vue?vue&type=script&lang=ts"
export * from "./army-stats-container.vue?vue&type=script&lang=ts"

import "./army-stats-container.vue?vue&type=style&index=0&id=2296b595&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2296b595"]])

export default __exports__